import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export default class MaintenanceListElementRepository extends EntityBaseRepository {

    public getAllItems(): Promise<AxiosResponse> {
        return this.axiosClient.get('/maintenanceListElement');
    }

    public createItem(item: any): Promise<AxiosResponse> {
        return this.axiosClient.post('/maintenanceListElement', item);
    }

    public getItem(id: number): Promise<AxiosResponse> {
        return this.axiosClient.get(`/maintenanceListElement/${id}`);
    }

    public getItemsByActuatorType(actuatorTypeId: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`/maintenanceListElement/actuatorType/${actuatorTypeId}`);
    }

    public updateItem(id: number, item: any): Promise<AxiosResponse> {
        return this.axiosClient.put(`/maintenanceListElement/${id}`, item);
    }

    public deleteItem(id: number): Promise<AxiosResponse> {
        return this.axiosClient.delete(`/maintenanceListElement/${id}`);
    }
    
}
